import service from "./service";

const bannerList = async ( search, page, limit,type) => {
  return service
    .get(`admin/banners?search=${search}&page=${page}&limit=${limit}&type=${type}`)
    .then((response) => {
      return response;
    });
};

const promotionalbannerList = async (search, page, limit) => {
  return service
    .get(
      `admin/banners?type=store&search=${search}&page=${page}&limit=${limit}`
    )
    .then((response) => {
      return response;
    });
};

const bannerListDelete = async (id) => {
  return service.deleteApi(`admin/banners/${id}`).then((response) => {
    return response;
  });
};

const bannerAdd = async (payload) => {
  return service.post(`admin/banners`, payload).then((response) => {
    return response;
  });
};

const getBannerById = async (id) => {
  return service.get(`admin/banners/${id}`).then((response) => {
    return response;
  });
};

const editBanner = async (id, payload) => {
  return service.patchApi(`admin/banners/${id}`, payload).then((response) => {
    return response;
  });
};

export default {
  bannerList,
  promotionalbannerList,
  bannerListDelete,
  bannerAdd,
  getBannerById,
  editBanner,
};
